import React, { FC } from 'react';
import { AddEntityWatcherButton } from '../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';

const source = 'lawyer_snippet';

type Props = {
  lawyerId: string;
  name: string;
};

export const LawyerFollowButton: FC<Props> = ({ lawyerId, name }) => {
  const { openRestrictedModal } = useRestrictedModal();
  return (
    <AddEntityWatcherButton
      entityIdParams={{ lid: lawyerId }}
      query={name}
      uniqueId={lawyerId}
      restrict={() => openRestrictedModal({ source: 'want_to_follow_lawyer' })}
      source={source}
      secondary
    />
  );
};
